const settings =
{
    layout :
    {
        style  : 'layout1',
        config :
        {
            scroll : 'content',
            navbar :
            {
                display : false,
                folded  : false,
                position: 'left'
            },
            toolbar:
            {
                display  : false,
                style    : 'fixed',
                position : 'below'
            },
            footer :
            {
                display  : false,
                style    : 'fixed',
                position : 'below'
            },
            mode : 'fullwidth'
        }
    },
    theme :
    {
        main   : 'default',
        navbar : 'mainThemeDark',
        toolbar: 'mainThemeDark',
        footer : 'mainThemeDark'
    },
    customScrollbars: true
};

export default settings;


// WEBPACK FOOTER //
// ./src/app/configs/settings.js